import React, { useEffect, useContext, useMemo, useState } from 'react'
import { IntlContext } from 'react-intl'
import { langStringToCode } from '../../Share/Tools/switchLang'
import { getOnlyStore } from '../../Api/GetStore'
const Tool_storeName = ({
  storeId,
  onError
}) => {
  const [ state, setState ] = useState({
    storeData: null,
    isLoading: true
  })
  const { locale } = useContext(IntlContext)
  const langId = useMemo(() => {
    return langStringToCode(locale)
  }, [ locale ])

  useEffect(() => {
    if ( storeId !== undefined  ) {
      setState({ isLoading: true })
      getOnlyStore(storeId, langId).then(res => {
        if ( res.data.errCode !== 200 ) {
          onError({ errCode: res.data.errCode })
        } else {
          setState({ isLoading: false, storeData: res.data.branch })
        }
      })
    }
  }, [ langId, storeId, onError ])
  return (
    <span>{ state.isLoading ? 'loading...' : state.storeData.name }</span>
  )
}

export default Tool_storeName